<template>
    <div>
        <!-- =============================================================================== -->

 <v-row justify="center">
            <v-dialog v-model="$store.state.showDialogGuia.carta" max-width="600px">
              <v-card>
                <v-card-title>
                  <span class="headline">Definir destinatário (Carta de recomendação)</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>

                      <v-col cols="12" sm="6">
                         <v-select
                         outlined
                          v-model="destinatario.enderecamentoCarta"
                          item-value="descricao"
                          item-text="descricao"
                          :items="enderecamentoCarta"
                          label="Selecione o endereçamento"
                        ></v-select>
                      </v-col>
                      <v-col cols="12" sm="6">
                         <v-textarea
                          outlined
                          :rules="[v => v.length >= 5 || 'Caracteres insuficientes']"
                          v-model="destinatario.descricao"
                          label="Informe a entidade"
                        ></v-textarea>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red" text @click="$store.state.showDialogGuia.carta=false">Cancelar</v-btn>
                   <v-btn :disabled="destinatario.descricao.length >= 5 && destinatario.enderecamentoCarta !== null" color="blue darken-1" text @click="getMediaEstudante($store.state.objAluno)">avancar</v-btn>
                 </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>

  <!--================================================================================== -->
    </div>
    </template>
<script>
import axios from '../../../plugins/axios'
import Swal from 'sweetalert2'
const ls = require('local-storage')
export default {
  data: () => ({
    enderecamentoCarta: [ ],
    destinatario: { enderecamentoCarta: null, descricao: '' },
    historicoNotas: [],
    historico_relatorio: [],
    relatorio: ls.get('relatorio-estudante'),
    html: ``,
    titulo: 'A Carta de Recomendação',
    configuracoesReport: ls.get('configuracoesReport')
  }),
  created  () {
    this.carregarRelatorio()
    this.carregarEnderecamento()
  },
  methods: {
    async carregarRelatorio () {
      try {
        let relatorio = 4
        this.historico_relatorio = await axios
          .get('/obterRelatorio/' + relatorio)
          .then(res => res.data)
      } catch (error) {
        this.sair()
        Swal.fire({
          icon: 'error',
          title: '',
          text: 'Ocorreu um erro ao carregar o relatório'
        })
      }
    },
    async carregarEnderecamento () {
      try {
        this.enderecamentoCarta = await axios
          .get('/obterEnderecamentoCarta')
          .then(res => res.data)
      } catch (error) {
        this.sair()
        Swal.fire({
          icon: 'error',
          title: '',
          text: 'Ocorreu um erro ao carregar'
        })
      }
    },
    async getMediaEstudante (item) {
      try {
        this.$store.state.showDialogGuia.carta = false
        let soma = 0
        let periodoFrequencia = await axios
          .get('/obterPeriodoFrequenciaByEstudante/' + item.idMatricula)
          .then(res => res.data)
        this.historicoNotas = await axios
          .post('/obter-disciplinas-pauta-modelo', item)
          .then(res => res.data)
        if (this.historicoNotas.length) {
          const pap = (this.historicoNotas.filter(h => h.descricao.includes('PAP')))
          const ec = (this.historicoNotas.filter(h => h.descricao.includes('(EC)')))
          this.historicoNotas.filter(h => !(h.descricao.includes('(PAP)') || h.descricao.includes('(EC)'))).forEach(element => {
            soma += (element.mfd === null) ? 0 : parseInt(element.mfd)
          })

          const pc = Math.round(soma / parseInt(this.historicoNotas.length - 2))
          const mediaFinal = Math.round((4 * pc + parseInt((pap.length ? pap[0].mfd : 0)) + parseInt((ec.length ? ec[0].mfd : 0))) / 6)

          this.comporCartaRecomendacao(item, periodoFrequencia, pap, mediaFinal)
        }
      } catch (error) {
        this.sair()
        Swal.fire({
          icon: 'error',
          title: '',
          text: 'Ocorreu um erro ao carregar ao obter as médias'
        })
      }
    },
    async comporCartaRecomendacao (item, periodoFrequencia, pap, mediaFinal) {
      try {
        let config = ls.get('configuracoesReport')
        let dg = config.filter(c => c.chave === 'director_geral')
        const ensino = config.filter(c => c.chave === 'tipo_ensino')
        let documento = (this.historico_relatorio.length ? this.historico_relatorio[0].documento : '')
        // @ts-ignore
        documento = documento.replace(/{{destinatario}}/g, (this.destinatario.enderecamentoCarta + '<br>' + this.destinatario.descricao.toUpperCase()))
        // @ts-ignore
        documento = documento.replace(/{{curso}}/g, item.curso.toUpperCase())
        documento = documento.replace(/{{logotipoInstituicao}}/g, ls.get('logotipo'))

        documento = documento.replace(/{{instituicao}}/g, (ls.get('instituicaodescricao').toUpperCase()))
        documento = documento.replace(/{{instituto}}/g, ls.get('instituicaodescricao'))
        documento = documento.replace(/{{nomeescola}}/g, ls.get('instituicaodescricao'))
        // @ts-ignore
        documento = documento.replace(/{{tempoconclusaocurso}}/g, (periodoFrequencia.length ? this.valorExtensao(periodoFrequencia[0].quant) + ' (' + periodoFrequencia[0].quant + ')' : 0))
        const periodo = (periodoFrequencia.length ? (periodoFrequencia[0].periodo).split(',') : 0)
        // @ts-ignore
        documento = documento.replace(/{{intervalotempo_conclusaocurso}}/g, (periodo.length ? (periodo[0] + ' a ' + periodo[periodo.length - 1]) : 0))
        // @ts-ignore
        documento = documento.replace(/{{tipoensino}}/g, (ensino.length ? ensino[0].valor : ''))
        // @ts-ignore
        documento = documento.replace(/{{nomeAluno}}/g, item.nome)

        const firstname = item.nome.split(' ')
        // @ts-ignore
        documento = documento.replace(/{{firstname}}/g, firstname[0])
        // @ts-ignore
        documento = documento.replace(/{{nomedopai}}/g, item.nomedopai)
        // @ts-ignore
        documento = documento.replace(/{{nomedamae}}/g, item.nomedamae)

        // @ts-ignore
        documento = documento.replace(/{{municipio}}/g, item.municipio)
        // @ts-ignore
        documento = documento.replace(/{{residencia}}/g, (item.morada ? item.morada : ''))
        // @ts-ignore
        documento = documento.replace(/{{provincia}}/g, item.provincia)
        const datadenascimento = (this.dataExtensao(item.datanascimento))
        const datadeemissao = (this.dataExtensaobi(item.dataemissaobi))

        documento = documento.replace(/{{datanascimento}}/g, (datadenascimento.length ? datadenascimento : ''))
        documento = documento.replace(/{{dataemissaobi}}/g, (datadeemissao.length ? datadeemissao : ''))
        // @ts-ignore
        documento = documento.replace(/{{bi}}/g, item.bi)
        // @ts-ignore
        documento = documento.replace(/{{sigla}}/g, item.sigla)
        // @ts-ignore
        documento = documento.replace(/{{matricula}}/g, item.idMatricula)
        documento = documento.replace(/{{director_profissao}}/g, '*' + dg[1].valor + '*')
        documento = documento.replace(/{{director}}/g, dg[0].valor)
        documento = documento.replace(/{{dataactual}}/g, this.dataActual())

        // @ts-ignore
        documento = documento.replace(/{{pap}}/g, (pap.length ? (pap[0].mfd === null ? '' : pap[0].mfd) : ''))
        // @ts-ignore
        documento = documento.replace(/{{media}}/g, (mediaFinal === null ? '' : mediaFinal))

        this.html = documento
        let options = {
          'format': 'A4',
          'border': {
          // default is 0, units: mm, cm, in, px
            'right': '15mm',
            'left': '15mm'
          },
          'header': {
            'height': '5mm' },
          'footer': {
            'height': '20mm',
            'contents': {
              last: this.historico_relatorio[0].documentoiteracao1
            }

          } }
        this.gerarPdf(options)
        this.destinatario = { enderecamentoCarta: null, descricao: '' }
      } catch (error) {
        this.sair()
        Swal.fire({
          icon: 'error',
          title: '',
          text: 'Ocorreu um erro ao compor a carta de recomendação'
        })
      }
    },
    async gerarPdf (option) {
      try {
        let result = await axios({
          method: 'post',
          url: ls.get('urlReport') + 'writefile',
          data: {
            html: this.html,
            file_name: ls.get('idPessoa'),
            option: option
          }
        }).then()
        this.frame()
      } catch (error) {
        this.sair()
        Swal.fire({
          icon: 'error',
          title: '',
          text: 'Ocorreu um erro ao compor o documento'
        })
      }
    },

    frame () {
      this.sair()
      let readfile = ls.get('urlReport') + 'readfile/' + ls.get('idPessoa') + '.pdf'
      let frame = `<html> +
          <style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style> 
          <body>
          <iframe target="_blank" type="application/pdf" src="` + readfile + `"></iframe> 
          </body></html>`
      let a = window.open('about:blank', '_blank', '', true)
      a.document.write(frame)
      a.document.close()
    },
    sair () {
      this.$store.state.isloading = false
      this.$store.state.showDialogGuia.carta = false
    },
    valorExtensao (valor) {
      switch (valor) {
        case 1:
          return 'um'
        case 2:
          return 'dois'
        case 3:
          return 'três'
        case 4:
          return 'quatro'
        case 5:
          return 'cinco'
        case 6:
          return 'seis'
        case 7:
          return 'sete'
        case 8:
          return 'oito'
        case 9:
          return 'nove'
        case 10:
          return 'dez'
        default:
          return 'Valor inválido'
      }
    },
    dataExtensao (dateString) {
      dateString = dateString.split('/')
      var month = []
      month[0] = 'Janeiro'
      month[1] = 'Fevereiro'
      month[2] = 'Março'
      month[3] = 'Abril'
      month[4] = 'Maio'
      month[5] = 'Junho'
      month[6] = 'Julho'
      month[7] = 'Agosto'
      month[8] = 'Setembro'
      month[9] = 'Outubro'
      month[10] = 'Novembro'
      month[11] = 'Dezembro'
      return dateString[0] + ' de ' + month[parseInt(dateString[1]) - 1] + ' de ' + dateString[2]
    },
    dataExtensaobi (dateString) {
      dateString = dateString.split('/')
      var month = []
      month[0] = 'Janeiro'
      month[1] = 'Fevereiro'
      month[2] = 'Março'
      month[3] = 'Abril'
      month[4] = 'Maio'
      month[5] = 'Junho'
      month[6] = 'Julho'
      month[7] = 'Agosto'
      month[8] = 'Setembro'
      month[9] = 'Outubro'
      month[10] = 'Novembro'
      month[11] = 'Dezembro'
      return dateString[0] + ' de ' + month[parseInt(dateString[1]) - 1] + ' de ' + dateString[2]
    },
    dataActual () {
      let data = new Date()
      var month = []
      month[0] = 'Janeiro'
      month[1] = 'Fevereiro'
      month[2] = 'Março'
      month[3] = 'Abril'
      month[4] = 'Maio'
      month[5] = 'Junho'
      month[6] = 'Julho'
      month[7] = 'Agosto'
      month[8] = 'Setembro'
      month[9] = 'Outubro'
      month[10] = 'Novembro'
      month[11] = 'Dezembro'
      return data.getDate().toString() + ' de ' + month[(data.getMonth())] + ' de ' + data.getFullYear().toString()
    }
  }
}

</script>
